const ReadOnlyTextWidget = ({ id, value }: { id: string; value: string }) => (
  <div
    key={id}
    css={{
      wordWrap: 'break-word',
      wordBreak: 'break-all',
    }}
  >
    {value}
  </div>
);

export default ReadOnlyTextWidget;
